// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Download = Symbol('Download');
